// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.featured-project-banner {\n\tposition: relative;\n}\n.super-module {\n\tright: 0px;\n\tmax-width: 70%;\n}\n", ""]);
// Exports
module.exports = exports;
